import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';

const RenotifyCountdown: React.FC<{ target: string | Date; color?: string }> = ({ target, color }) => {
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick(t => t + 1), 1000);
    return () => clearInterval(id);
  }, []);
  const ms = new Date(target).getTime() - Date.now();
  const overdue = ms <= 0;
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const label = overdue ? 'due'
    : h > 0 ? `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    : `${m}:${String(s).padStart(2, '0')}`;
  void tick;
  return (
    <Typography component="span" variant="caption" sx={{ fontSize: '0.62rem', fontWeight: 600, color: overdue ? '#c27803' : color }}>
      ⏱ next in {label}
    </Typography>
  );
};

export default RenotifyCountdown;
